"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var LinkedIn = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M17.6348754,17.6337778 L15.2626394,17.6337778 L15.2626394,13.9202963 C15.2626394,13.0346667 15.2469351,11.8957037 14.0294085,11.8957037 C12.7943998,11.8957037 12.6059484,12.861037 12.6059484,13.8568889 L12.6059484,17.6337778 L10.2337124,17.6337778 L10.2337124,9.99822222 L12.5099448,9.99822222 L12.5099448,11.0423704 L12.5425386,11.0423704 C12.8592911,10.4417778 13.633542,9.80888889 14.7879551,9.80888889 C17.1913034,9.80888889 17.6348754,11.3899259 17.6348754,13.4459259 L17.6348754,17.6337778 Z M7.55835401,8.95496296 C6.79773325,8.95496296 6.18289566,8.33837037 6.18289566,7.57925926 C6.18289566,6.81925926 6.79773325,6.20266667 7.55835401,6.20266667 C8.31690063,6.20266667 8.93351606,6.81925926 8.93351606,7.57925926 C8.93351606,8.33837037 8.31690063,8.95496296 7.55835401,8.95496296 Z M6.37134709,17.6337778 L8.74536094,17.6337778 L8.74536094,9.99822222 L6.37134709,9.99822222 L6.37134709,17.6337778 Z M18.8165488,4 L5.18078447,4 C4.52950109,4 4,4.51674074 4,5.15377778 L4,18.8456296 C4,19.4826667 4.52950109,20 5.18078447,20 L18.8165488,20 C19.4693137,20 20,19.4826667 20,18.8456296 L20,5.15377778 C20,4.51674074 19.4693137,4 18.8165488,4 L18.8165488,4 Z", fillRule: "evenodd" })));
};
LinkedIn.displayName = 'LinkedIn';
exports.default = LinkedIn;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=LinkedIn.js.map